import React, { useLayoutEffect, useRef, useState } from 'react';

import { Popover, Portal } from '@headlessui/react';

import { cn } from 'lib/helpers/utility';

/**
 * @type {import('./lib/types').DisplayButtonWrapperProps}
 */
const DisplayButtonWrapper = ({
  buttonContent,
  panelContent,
  panelClassName = '',
  buttonClassName = ''
}) => {
  const buttonRef = useRef(null);
  const [position, setPosition] = useState(null);

  useLayoutEffect(() => {
    const update = () => {
      const btn = buttonRef.current;
      if (!btn || typeof window === 'undefined') return;
      const rect = btn.getBoundingClientRect();
      const top = rect.bottom + 8; // small offset below the button
      const right = Math.max(8, window.innerWidth - rect.right);
      setPosition({
        top: Math.round(top),
        right: Math.round(right),
        minWidth: Math.max(Math.round(rect.width), 300)
      });
    };

    update();
    window.addEventListener('resize', update);
    window.addEventListener('scroll', update, true);
    return () => {
      window.removeEventListener('resize', update);
      window.removeEventListener('scroll', update, true);
    };
  }, []);

  return (
    <Popover className="relative">
      {({ open }) => (
        <>
          <Popover.Button ref={buttonRef} className={cn('p-0', buttonClassName)}>
            {buttonContent(open)}
          </Popover.Button>
          {open && (
            <Portal>
              <Popover.Panel
                className={cn(
                  'z-[50000] max-h-[576px] overflow-y-auto rounded border border-solid border-neutral-200 bg-white p-0 shadow-[0px_0px_16px_rgba(55,65,69,0.08)]',
                  panelClassName
                )}
                style={
                  position
                    ? {
                        position: 'fixed',
                        top: `${position.top}px`,
                        right: `${position.right}px`,
                        minWidth: `${position.minWidth}px`
                      }
                    : { position: 'fixed', visibility: 'hidden' }
                }>
                {panelContent()}
              </Popover.Panel>
            </Portal>
          )}
        </>
      )}
    </Popover>
  );
};

export default DisplayButtonWrapper;
